import React from 'react'
import { UserCircle, Shield, LogOut, HardDrive } from 'lucide-react'

const menuItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  padding: '8px 10px',
  border: 'none',
  borderRadius: '6px',
  background: 'transparent',
  cursor: 'pointer',
  fontSize: '13px',
  color: 'var(--color-text-primary)',
  textAlign: 'left',
}

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {() => void} props.onProfile
 * @param {() => void} [props.onPersonalLibrary]
 * @param {boolean} [props.showPersonalLibrary]
 * @param {() => void} [props.onAdminPanel]
 * @param {boolean} [props.showAdminPanel]
 * @param {() => void} props.onLogout
 */
export default function UserAccountMenu({
  open,
  onProfile,
  onPersonalLibrary,
  showPersonalLibrary = false,
  onAdminPanel,
  showAdminPanel = false,
  onLogout,
}) {
  if (!open) return null

  return (
    <div
      role="menu"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '100%',
        transform: 'translateY(10px)',
        backgroundColor: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        borderRadius: '8px',
        boxShadow: 'var(--shadow-sm)',
        padding: '6px',
        zIndex: 20,
      }}
    >
      <button type="button" role="menuitem" onClick={onProfile} style={menuItemStyle}>
        <UserCircle size={16} /> Profile
      </button>
      {showPersonalLibrary && typeof onPersonalLibrary === 'function' ? (
        <button type="button" role="menuitem" onClick={onPersonalLibrary} style={menuItemStyle}>
          <HardDrive size={16} /> Personal Library
        </button>
      ) : null}
      {showAdminPanel && typeof onAdminPanel === 'function' ? (
        <button type="button" role="menuitem" onClick={onAdminPanel} style={menuItemStyle}>
          <Shield size={16} /> Admin Panel
        </button>
      ) : null}
      <button
        type="button"
        role="menuitem"
        onClick={onLogout}
        style={{ ...menuItemStyle, color: '#b91c1c' }}
      >
        <LogOut size={16} /> Logout
      </button>
    </div>
  )
}

export const USER_MENU_CLOSE_MS = 220
